<template>
	<div class="personDetail-container">
		<div class="personDetail-content">
			<!-- vip滚动区域--start -->
			<div class="vip-container">
				<div class="vip-content">
					<div class="vip-swiper">
						<ul class="swiper-wrapper">
							<li v-for="(item, index) in vipMessages" :key="index" class="swiper-slide">
								<i class="iconfont icon-gouwuche"></i>
								<p>{{ item.message }}</p>
								<el-button @click="handleToPurchase">立即购买</el-button>
							</li>
						</ul>
					</div>
					<div class="export-content">
						<span @click="handleExportPersonReport">
							<svg-icon icon-class="export" class="icon" />
							导出报告
						</span>
						<span :class="{ activeCollect: detailInfo.isCollect }" @click="handleIsCollect(detailInfo.id, detailInfo.isCollect)">
							<svg-icon v-if="detailInfo.isCollect" icon-class="collected" class="icon" />
							<svg-icon v-else icon-class="collect" class="icon" />
							{{ detailInfo.isCollect ? '已收藏' : '收藏' }}
						</span>
						<span
							:class="{ activeMonitor: detailInfo.isMonitoring }"
							@click="handleIsMonitoring(detailInfo.id, detailInfo.isMonitoring)"
						>
							<svg-icon v-if="detailInfo.isMonitoring" icon-class="monitored" class="icon" />
							<svg-icon v-else icon-class="monitor" class="icon" />
							{{ detailInfo.isMonitoring ? '已监控' : '监控' }}
						</span>
					</div>
				</div>
			</div>
			<!-- vip滚动区域--end -->
			<!-- 人员信息--start -->
			<div class="information-container">
				<div class="information-content">
					<div class="basic-content">
						<div v-loading="loading" class="tab-container">
							<div class="cjt-tabs">
								<div class="section-sub-title">
									<h4>人员基本信息</h4>
								</div>
								<div class="cjt-tabs__content">
									<img src="@/assets/user/user-avator.png" alt="" />
									<div class="basic-info">
										<h4 class="name">
											{{ detailInfo.name }}
											<!-- <span class="on-job">{{ getWorkStatus(detailInfo.workStatus) }}/人才库</span> -->
										</h4>
										<p>
											<span>性别：{{ detailInfo.sex }}</span>
											<span>证件类型：{{ detailInfo.certTypeName }}</span>
											<span>证件号码：{{ detailInfo.idCard }}</span>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="people-content">
						<div class="vip-title">
							人员画像
							<!-- <span class="tag-member-mini tag-member--vip">VIP</span> -->
						</div>
						<div v-loading="portraitLoading" class="people-echarts">
							<radar-chart
								ref="radarChart"
								:chart-data="portraitData"
								:indicator="portraitIndicator"
								title="能力评估雷达图"
								height="230px"
							/>
						</div>

						<!-- 未开通会员提示 -->
						<!-- 目前系统暂无会员控制，改为购买服务 -->
						<!-- <nonbind-vip v-if="isNormalVip" class-name="small-mask-content"></nonbind-vip> -->
					</div>
				</div>
			</div>
			<!-- 人员信息--end -->

			<!-- 滑动tab--start -->
			<ul class="slide-tab">
				<li
					v-for="(item, index) in dynamicSilideList"
					:key="index"
					:class="{ active: activeSlideTabIndex === index }"
					@click="changeSlideTab(index)"
				>
					{{ item.name }}
					<span class="num">{{ item.num }}</span>
					<!-- <span v-if="item.isVip" class="tag-member-mini tag-member--vip">VIP</span> -->
				</li>
			</ul>
			<!-- 滑动tab--start -->

			<!-- 表格echars--start -->
			<div class="table-container">
				<div class="table-content">
					<div class="table-box">
						<div class="tab-container">
							<div class="cjt-tabs">
								<div class="section-sub-title slideTitle">
									<h4>
										注册信息
										<span>（{{ registerRecords.registered.pageOptions.total }}）</span>
									</h4>
								</div>
								<div class="cjt-tabs__content">
									<!-- 注册信息表格 -->
									<div class="register-table mt20">
										<data-table
											:table-data="registerRecords.registered.list"
											:column="registerRecords.registered.columns"
											:page-options="registerRecords.registered.pageOptions"
											:border="false"
											:index="true"
											:loading="registerRecords.registered.loading"
											@page-change="pager => handleRegisterPageChange(pager, 'registered')"
										>
											<template slot="slot_tools" slot-scope="data">
												<el-button
													type="text"
													@click="
														handleOpenDialog('CertificateInfoVoDetail', '证书记录', data.scope.row.id, data.scope.row.idCard)
													"
												>
													证书记录
												</el-button>
											</template>
										</data-table>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-container mt20">
							<div class="cjt-tabs">
								<div class="section-sub-title slideTitle">
									<h4>
										非注册信息
										<span>（{{ registerRecords.nonRegistered.pageOptions.total }}）</span>
									</h4>
								</div>
								<div class="cjt-tabs__content">
									<!-- 非注册信息表格 -->
									<div class="register-table mt20">
										<data-table
											:table-data="registerRecords.nonRegistered.list"
											:column="registerRecords.nonRegistered.columns"
											:page-options="registerRecords.nonRegistered.pageOptions"
											:border="false"
											:index="true"
											:loading="registerRecords.nonRegistered.loading"
											@page-change="pager => handleRegisterPageChange(pager, 'nonRegistered')"
										>
											<template slot="slot_certificateSubName" slot-scope="data">
												{{
													data.scope.row.certificateSubName ? data.scope.row.certificateSubName : data.scope.row.certificateName
												}}
											</template>
										</data-table>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-container mt20">
							<div class="cjt-tabs">
								<div class="section-sub-title slideTitle">
									<h4>
										待注册信息
										<span>（{{ registerRecords.waiting.pageOptions.total }}）</span>
									</h4>
								</div>
								<div class="cjt-tabs__content">
									<div>
										<!-- 待注册信息表格 -->
										<div class="register-table mt20">
											<data-table
												:table-data="registerRecords.waiting.list"
												:column="registerRecords.waiting.columns"
												:page-options="registerRecords.waiting.pageOptions"
												:border="false"
												:index="true"
												:loading="registerRecords.waiting.loading"
												@page-change="pager => handleRegisterPageChange(pager, 'waiting')"
											></data-table>
										</div>
										<!-- 未开通会员提示 -->
										<!-- 目前系统暂无会员控制，改为购买服务 -->
										<!-- <nonbind-vip v-if="isNormalVip"></nonbind-vip> -->
									</div>
								</div>
							</div>
						</div>
						<div class="tab-container mt20">
							<div class="cjt-tabs">
								<div class="section-sub-title slideTitle">
									<h4>
										个人工程业绩
										<span>（{{ personalProjectPerformancePageOptions.total }}）</span>
									</h4>
								</div>
								<div class="cjt-tabs__content">
									<!-- 个人工程业绩表格 -->
									<div class="register-table mt20">
										<data-table
											:table-data="personalProjectPerformanceList"
											:column="personalProjectPerformanceColumns"
											:page-options="personalProjectPerformancePageOptions"
											:border="false"
											:index="true"
											:loading="personalProjectPerformanceLoading"
											@page-change="handlePersonalProjectPerformancePageChange"
										>
											<template slot="slot_tools" slot-scope="data">
												<el-tooltip class="item" effect="dark" :content="data.scope.row.constructionScale" placement="top">
													<p class="max-text">{{ data.scope.row.constructionScale }}</p>
												</el-tooltip>
											</template>
										</data-table>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-container mt20">
							<div class="cjt-tabs">
								<div class="section-sub-title slideTitle">
									<h4>
										个人业绩技术指标
										<span>（{{ personTechnicalIndexPageOptions.total }}）</span>
									</h4>
								</div>
								<div class="cjt-tabs__content">
									<!-- 个人业绩技术指标表格 -->
									<div class="register-table mt20">
										<data-table
											:table-data="personTechnicalIndexList"
											:column="personTechnicalIndexColumns"
											:page-options="personTechnicalIndexPageOptions"
											:border="false"
											:index="true"
											:loading="personTechnicalIndexLoading"
											@page-change="handlePersonTechnicalIndexPageChange"
										>
											<template slot="slot_tools" slot-scope="data">
												<el-tooltip class="item" effect="dark" :content="data.scope.row.constructionScale" placement="top">
													<p class="max-text">{{ data.scope.row.constructionScale }}</p>
												</el-tooltip>
											</template>
										</data-table>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-container mt20">
							<div class="cjt-tabs">
								<div class="section-sub-title slideTitle">
									<h4>
										良好行为
										<span>（{{ behaviorRecords.good.pageOptions.total }}）</span>
									</h4>
								</div>
								<div class="cjt-tabs__content">
									<!-- 良好行为绩表格 -->
									<div class="register-table mt20">
										<data-table
											:table-data="behaviorRecords.good.list"
											:column="behaviorRecords.good.columns"
											:page-options="behaviorRecords.good.pageOptions"
											:border="false"
											:index="true"
											:loading="behaviorRecords.good.loading"
											@page-change="pager => handleBehaviorPageChange(pager, 'good')"
										>
											<template slot="slot_validityTime" slot-scope="data">
												{{ data.scope.row.makeTime + ' 至 ' + data.scope.row.validityTime }}
											</template>
											<template slot="slot_tools" slot-scope="data">
												<el-button type="text" @click="handleOpenDialog('GoodBehaviorDetail', '良好行为详情', data.scope.row.id)">
													查看
												</el-button>
											</template>
										</data-table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="charts-box">
						<div class="vip-title">
							人员分析
							<!-- <span class="tag-member-mini tag-member--vip">VIP</span> -->
						</div>
						<div class="charts-content">
							<div class="chars-title">
								技能分析
							</div>
							<div class="divider-title">
								<span class="title-text">证件数量</span>
							</div>
							<div v-loading="certCountRankLoading" class="progress-box">
								<progress-chart
									ref="certCountChart"
									:value="certCountRank.percentile"
									:title="certCountRank.title"
									:sub-title="certCountRank.subTitle"
									color="#ff6a3d"
									height="100%"
									width="100%"
								/>

								<!-- 未开通会员提示 -->
								<!-- 目前系统暂无会员控制，改为购买服务 -->
								<!-- <nonbind-vip v-if="isNormalVip" class-name="small-mask-content"></nonbind-vip> -->
							</div>

							<!-- <div class="divider-title" style="margin-top: 0px;">
								<span class="title-text">证书分类</span>
							</div>

							<div v-loading="certTypeDataLoading" class="chart-box">
								<person-donut-chart
									ref="certTypeChart"
									:chart-data="certTypeData"
									:center-text="certTypeTotal"
									:show-legend="true"
									height="250px"
									width="100%"
								/>
							</div> -->

							<!-- 会员广告已屏蔽
							<div class="poster-container">
								<img
									src="@/assets/qualificationQuery/vip1.jpg"
									alt="VIP限时专享，资质办理加速跑"
									@click="handleLocationMemberBenefits"
								/>
							</div>
							-->

							<div class="divider-title">
								<span class="title-text">证件级别</span>
							</div>
							<div v-loading="certGradeRankLoading" class="progress-box">
								<progress-chart
									ref="certGradeChart"
									:value="certGradeRank.percentile"
									:title="certGradeRank.title"
									:sub-title="certGradeRank.subTitle"
									color="#ff6a3d"
									height="100%"
									width="100%"
								/>

								<!-- 未开通会员提示 -->
								<!-- 目前系统暂无会员控制，改为购买服务 -->
								<!-- <nonbind-vip v-if="isNormalVip" class-name="small-mask-content"></nonbind-vip> -->
							</div>

							<div class="divider-title" style="margin-top: 0px;">
								<span class="title-text">风险评估</span>
							</div>

							<div v-loading="personRiskDataLoading" class="chart-box">
								<person-risk-donut-chart
									ref="riskChart"
									:chart-data="personRiskData"
									:show-legend="true"
									legend-position="right"
									height="250px"
									width="100%"
								></person-risk-donut-chart>

								<!-- 未开通会员提示 -->
								<!-- 目前系统暂无会员控制，改为购买服务 -->
								<!-- <nonbind-vip v-if="isNormalVip" class-name="small-mask-content"></nonbind-vip> -->
							</div>

							<!-- 会员广告已屏蔽
							<div class="poster-container">
								<img
									src="@/assets/qualificationQuery/vip2.jpg"
									alt="VIP限时专享，资质办理加速跑"
									@click="handleLocationMemberBenefits"
								/>
							</div>
							-->

							<div class="divider-title">
								<span class="title-text">稳定性分析</span>
							</div>

							<div v-loading="stabilityDataLoading" class="chart-box">
								<person-stability-line-chart
									ref="stabilityChart"
									:chart-data="stabilityData"
									:x-axis-data="stabilityMonthData"
									line-color="#1890ff"
									height="250px"
									default-period="year"
									@period-change="handleStabilityPeriodChange"
								/>

								<!-- 未开通会员提示 -->
								<!-- 目前系统暂无会员控制，改为购买服务 -->
								<!-- <nonbind-vip v-if="isNormalVip" class-name="small-mask-content"></nonbind-vip> -->
							</div>

							<div class="divider-title">
								<span class="title-text">个人行为记录</span>
							</div>
							<div v-loading="behaviorDataLoading" class="chart-box">
								<person-behavior-bar-chart
									ref="behaviorChart"
									:good-behavior-data="goodBehaviorData"
									:bad-behavior-data="badBehaviorData"
									:blacklist-data="blacklistData"
									:month-data="behaviorMonthData"
									height="250px"
								/>

								<!-- 未开通会员提示 -->
								<!-- 目前系统暂无会员控制，改为购买服务 -->
								<!-- <nonbind-vip v-if="isNormalVip" class-name="small-mask-content"></nonbind-vip> -->
							</div>

							<!-- 会员广告已屏蔽
							<div class="poster-container" style="margin-bottom:19px">
								<img
									src="@/assets/qualificationQuery/vip3.jpg"
									alt="VIP限时专享，资质办理加速跑"
									@click="handleLocationMemberBenefits"
								/>
							</div>
							-->
						</div>
					</div>
				</div>
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>
								不良行为
								<span>
									<span>（{{ behaviorRecords.bad.pageOptions.total }}）</span>
								</span>
							</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 不良行为表格 -->
							<div class="register-table mt20">
								<data-table
									:table-data="behaviorRecords.bad.list"
									:column="behaviorRecords.bad.columns"
									:page-options="behaviorRecords.bad.pageOptions"
									:border="false"
									:index="true"
									:loading="behaviorRecords.bad.loading"
									@page-change="pager => handleBehaviorPageChange(pager, 'bad')"
								>
									<template slot="slot_validityTime" slot-scope="data">
										{{ data.scope.row.makeTime + ' 至 ' + data.scope.row.validityTime }}
									</template>
									<template slot="slot_tools" slot-scope="data">
										<el-button type="text" @click="handleOpenDialog('BadBehaviorDetail', '不良行为详情', data.scope.row.id)">
											查看
										</el-button>
									</template>
								</data-table>
							</div>
						</div>
					</div>
				</div>
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>
								行政处罚
								<span>（{{ behaviorRecords.punishment.pageOptions.total }}）</span>
							</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<!-- 行政处罚表格 -->
								<div class="register-table mt20">
									<data-table
										:table-data="behaviorRecords.punishment.list"
										:column="behaviorRecords.punishment.columns"
										:page-options="behaviorRecords.punishment.pageOptions"
										:border="false"
										:index="true"
										:loading="behaviorRecords.punishment.loading"
										@page-change="pager => handleBehaviorPageChange(pager, 'punishment')"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button type="text" @click="handleOpenDialog('PunishmentDetail', '行政处罚详情', data.scope.row.id)">
												查看
											</el-button>
										</template>
									</data-table>
								</div>
								<!-- 未开通会员提示 -->
								<!-- 目前系统暂无会员控制，改为购买服务 -->
								<!-- <nonbind-vip v-if="isNormalVip"></nonbind-vip> -->
							</div>
						</div>
					</div>
				</div>
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>
								黑名单记录
								<span>（{{ behaviorRecords.blackList.pageOptions.total }}）</span>
							</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<!-- 黑名单记录表格 -->
								<div class="register-table mt20">
									<data-table
										:table-data="behaviorRecords.blackList.list"
										:column="behaviorRecords.blackList.columns"
										:page-options="behaviorRecords.blackList.pageOptions"
										:border="false"
										:index="true"
										:loading="behaviorRecords.blackList.loading"
										@page-change="pager => handleBehaviorPageChange(pager, 'blackList')"
									>
										<template slot="slot_validityTime" slot-scope="data">
											{{ data.scope.row.makeTime + ' 至 ' + data.scope.row.validityTime }}
										</template>
										<template slot="slot_tools" slot-scope="data">
											<el-button
												type="text"
												@click="handleOpenDialog('BlacklistRecordsDetail', '黑名单记录详情', data.scope.row.id)"
											>
												查看
											</el-button>
										</template>
									</data-table>
								</div>
								<!-- 未开通会员提示 -->
								<!-- 目前系统暂无会员控制，改为购买服务 -->
								<!-- <nonbind-vip v-if="isNormalVip"></nonbind-vip> -->
							</div>
						</div>
					</div>
				</div>
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>
								黑名单及联合惩戒详情
								<span>（{{ behaviorRecords.blackListAndPenalty.pageOptions.total }}）</span>
							</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<!-- 黑名单及联合惩戒详情表格 -->
								<div class="register-table mt20">
									<data-table
										:table-data="behaviorRecords.blackListAndPenalty.list"
										:column="behaviorRecords.blackListAndPenalty.columns"
										:page-options="behaviorRecords.blackListAndPenalty.pageOptions"
										:border="false"
										:index="true"
										:loading="behaviorRecords.blackListAndPenalty.loading"
										@page-change="pager => handleBehaviorPageChange(pager, 'blackListAndPenalty')"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button
												type="text"
												@click="handleOpenDialog('BlacklistPunishment', '黑名单及联合惩戒', data.scope.row.id)"
											>
												查看
											</el-button>
										</template>
									</data-table>
								</div>
								<!-- 未开通会员提示 -->
								<!-- 目前系统暂无会员控制，改为购买服务 -->
								<!-- <nonbind-vip v-if="isNormalVip"></nonbind-vip> -->
							</div>
						</div>
					</div>
				</div>
			</div>

			<jr-dialog :visible.sync="showDialog" :title="dialogTitle" width="70%" :append-to-body="true" :show-btn="false">
				<template v-if="showDialog" slot="content">
					<component
						:is="currentDialogComponent"
						:id="currentDialogInfoId"
						ref="dialogComponent"
						:id-card="peopleIdCard"
						:is-risk="false"
					></component>
				</template>
			</jr-dialog>

			<!-- 购买会员弹窗 -->
			<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleVipCancel">
				<template slot="title">
					<!-- 自定义弹窗标题 -->
					<h4 class="model-title">
						<span>购买会员</span>
					</h4>
				</template>
				<template slot="content">
					<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
				</template>
			</jr-dialog>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import JrDialog from '@/components/Dialog'
	import RadarChart from '@/components/Chart/RadarChart.vue'
	import ProgressChart from '@/components/Chart/ProgressChart.vue'
	import DistributionLineChart from '@/components/Chart/DistributionLineChart.vue'
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import DataTable from '@/components/JrTable/DataTable.vue'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	// 良好行文详情
	import GoodBehaviorDetail from './components/person/goodBehaviorDetail.vue'
	// 不良行为详情
	import BadBehaviorDetail from './components/person/badBehaviorDetail.vue'
	// 处罚详情
	import PunishmentDetail from './components/person/punishmentDetail.vue'
	// 黑名单详情
	import BlacklistRecordsDetail from './components/person/blacklistRecordsDetail.vue'
	// 黑名单联合及惩戒
	import BlacklistPunishment from './components/person/blacklistPunishment.vue'
	// 证书记录
	import CertificateInfoVoDetail from './components/person/certificateInfoVoDetail.vue'
	import PersonDonutChart from '@/components/Chart/PersonDonutChart.vue'
	import PersonRiskDonutChart from '@/components/Chart/PersonRiskDonutChart.vue'
	import PersonStabilityLineChart from '@/components/Chart/PersonStabilityLineChart.vue'
	import PersonBehaviorBarChart from '@/components/Chart/PersonBehaviorBarChart.vue'
	import { mapGetters } from 'vuex'
// import { ENUM_MEMBER_BENEFIT } from '@/enum/memberBenefitRecord'
	import memberBenefitCheckerMixins from '@/mixins/memberBenefitCheckerMixins'
	import { COLLECT_TYPE_STATE } from '@/enum/index'
	import {
		getPersonDetail, // 人员详情
		pageUserProjectPerformanceTab, // 人员工程业绩
		personTechnicalIndexPageTab, // 人员技术指标
		personBehaviorRecordPageTab, // 人员行为记录
		pageCertificateByPersonId, // 人员信息表
		personPortrayal,
		personCerCountRank,
		personCerGradeRank,
		personRisk,
		personStability,
		personBehavior,
		personCerTypeCount,
		exportPersonReport
	} from '@/api/qualificationQuery/person'
	import { reportGenerationDownload } from '@/utils/request'
	import { saveUserCollect, removeUserCollect, saveUserMonitoring, removeUserMonitoring } from '@/api/userCenter/index'

	export default {
		name: 'PersonDetail',
		components: {
			JrDialog,
			RadarChart,
			ProgressChart,
			DistributionLineChart,
			PersonDonutChart,
			PersonRiskDonutChart,
			PersonStabilityLineChart,
			PersonBehaviorBarChart,
			NonbindVip,
			DataTable,
			GoodBehaviorDetail,
			BadBehaviorDetail,
			PunishmentDetail,
			BlacklistRecordsDetail,
			BlacklistPunishment,
			CertificateInfoVoDetail,
			PaymentDialog
		},
		// 使用会员权益前置校验mixins
		mixins: [memberBenefitCheckerMixins],
		props: {},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				showDialog: false,
				dialogTitle: '',
				currentDialogComponent: '',
				// 当前弹窗查看的信息id
				currentDialogInfoId: '',
				// 人员身份证
				peopleIdCard: '',

				personId: '',
				detailInfo: {}, // 人员信息详情
				activeSlideTabIndex: 0,
				vipMessages: [
					{ message: '李** 于3分钟前购买资质查，一键解锁全部权益' },
					{ message: '王** 于5分钟前购买资质查，一键解锁全部权益' },
					{ message: '张** 于10分钟前购买资质查，一键解锁全部权益' }
				],
				// 人员画像雷达图数据
				portraitIndicator: [
					{ name: '专业技能', max: 5 },
					{ name: '稳定性', max: 5 },
					{ name: '从业年限', max: 5 },
					{ name: '经验', max: 5 },
					{ name: '风险', max: 5 }
				],
				// 人员画像数据
				portraitData: [
					{
						value: [],
						name: '个人能力'
					}
				],
				portraitLoading: false,

				// 人员证书数量及其占比
				certCountRank: {
					// 占比
					percentile: 0,
					title: '',
					subTitle: '证件数量超过同类人'
				},
				certCountRankLoading: false,

				// 人员证书等级及其占比
				certGradeRank: {
					// 占比
					percentile: 0,
					title: '',
					subTitle: '证件数量超过同类人'
				},
				certGradeRankLoading: false,

				// 人员证书分类分析数据
				certTypeData: [
					// { value: 8, name: '资质类型1' },
					// { value: 5, name: '资质类型2' },
					// { value: 3, name: '资质类型3' },
					// { value: 2, name: '资质类型4' },
					// { value: 2, name: '资质类型5' },
					// { value: 4, name: '资质类型6' },
					// { value: 5, name: '资质类型7' },
					// { value: 6, name: '资质类型8' },
					// { value: 6, name: '资质类型9' },
					// { value: 6, name: '资质类型10' },
					// { value: 6, name: '资质类型11' }
				],
				// 证书分类
				certTypeTotal: '',
				certTypeDataLoading: false,

				// 人员风险评估
				personRiskData: [
					{ value: 0, name: '低风险' },
					{ value: 0, name: '中等风险' },
					{ value: 0, name: '高风险' }
				],
				personRiskDataLoading: false,

				// 人员稳定性分析数据
				stabilityMonthData: [],
				stabilityData: [],
				stabilityDataLoading: false,

				// 行为统计数据
				// 良好行为
				goodBehaviorData: [],
				// 不良行为
				badBehaviorData: [],
				// 黑名单
				blacklistData: [],
				// 时间周期
				behaviorMonthData: [],
				behaviorDataLoading: false,

				// 所有图表数据是否全部加载完毕，便于进行报告导出
				allChartDataIsLoadingDone: false,

				loading: false, // 人员详情loading

				// 人员信息
				registerRecords: {
					registered: {
						list: [],
						loading: false,
						columns: [
							{ label: '证书名称', prop: 'certificateName', align: 'center' },
							{ label: '注册单位', prop: 'registerUnitName', align: 'center' },
							{ label: '注册专业', prop: 'registerProject', align: 'center' },
							{ label: '注册日期', prop: 'registerTime', align: 'center' },
							{ label: '有效期', prop: 'validityTime', align: 'center' },
							{ label: '操作', prop: '', align: 'center', slot: 'slot_tools', width: '200' }
						],
						pageOptions: {
							currentPage: 1,
							limit: 3,
							total: 0,
							registerType: '1'
						}
					},
					nonRegistered: {
						list: [],
						loading: false,
						columns: [
							{ label: '证书名称', prop: 'certificateName', align: 'center' },
							{ label: '证书类型', prop: 'certificateSubName', align: 'center', width: '200', slot: 'slot_certificateSubName' },
							{ label: '证书编号', prop: 'certificateCode', align: 'center' },
							{ label: '有效期', prop: 'validityTime', align: 'center' }
						],
						pageOptions: {
							currentPage: 1,
							limit: 3,
							total: 0,
							registerType: '2'
						}
					},
					waiting: {
						list: [],
						loading: false,
						columns: [
							{ label: '企业名称', prop: 'registerUnitName', align: 'center' },
							{ label: '专业', prop: 'registerProject', align: 'center' },
							{ label: '证书编号', prop: 'certificateCode', align: 'center' }
						],
						pageOptions: {
							currentPage: 1,
							limit: 3,
							total: 0,
							registerType: '0'
						}
					}
				},

				// 个人工程业绩列表
				personalProjectPerformanceList: [],
				personalProjectPerformanceColumns: [
					{ label: '项目名称', prop: 'projectName', align: 'center' },
					{ label: '项目地址', prop: 'address', align: 'center' },
					{ label: '工程类别', prop: 'projectTypeName', align: 'center' },
					{ label: '项目编码', prop: 'projectCode', align: 'center', width: '200' },
					{ label: '所属地区', prop: 'countyName', align: 'center' },
					{ label: '状态', prop: 'remark', align: 'center' },
					{ label: '详细', prop: '', align: 'center', slot: 'slot_tools' }
				],
				personalProjectPerformancePageOptions: {
					currentPage: 1,
					limit: 3,
					total: 0
				},
				personalProjectPerformanceLoading: false,

				// 个人业绩技术指标
				personTechnicalIndexList: [],
				personTechnicalIndexColumns: [
					{ label: '项目名称', prop: 'projectName', align: 'center' },
					{ label: '个人业绩记录编号', prop: 'performanceCode', align: 'center', width: '200' },
					{ label: '项目编码', prop: 'projectCode', align: 'center' },
					{ label: '本人在工程中所起作用', prop: 'projectRoleName', align: 'center' },
					{ label: '数据等级', prop: 'level', align: 'center' },
					{ label: '详细', prop: '', align: 'center', slot: 'slot_tools' }
				],
				personTechnicalIndexPageOptions: {
					currentPage: 1,
					limit: 3,
					total: 0
				},
				personTechnicalIndexLoading: false,

				// 人员行为记录
				behaviorRecords: {
					good: {
						list: [],
						loading: false,
						columns: [
							{ label: '诚信记录主体及编号', prop: 'behaviorCode', align: 'center' },
							{ label: '决定内容', prop: 'behaviorContent', align: 'center' },
							{ label: '实施部门', prop: 'depart', align: 'center' },
							{ label: '决定日期与有效期', prop: 'validityTime', align: 'center', width: '300', slot: 'slot_validityTime' },
							{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
						],
						pageOptions: {
							currentPage: 1,
							limit: 3,
							total: 0,
							behaviorType: '0'
						}
					},
					bad: {
						list: [],
						loading: false,
						columns: [
							{ label: '诚信记录主体及编号', prop: 'behaviorCode', align: 'center' },
							{ label: '决定内容', prop: 'behaviorContent', align: 'center' },
							{ label: '实施部门', prop: 'depart', align: 'center' },
							{ label: '决定日期与有效期', prop: 'validityTime', align: 'center', width: '300', slot: 'slot_validityTime' },
							{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
						],
						pageOptions: {
							currentPage: 1,
							limit: 3,
							total: 0,
							behaviorType: '1'
						}
					},
					punishment: {
						list: [],
						loading: false,
						columns: [
							{ label: '行政处罚主体及编号', prop: 'behaviorCode', align: 'center' },
							{ label: '内容描述', prop: 'behaviorContent', align: 'center' },
							{ label: '登记部门', prop: 'registerDept', align: 'center' },
							{ label: '登记时间', prop: 'registerTime', align: 'center' },
							{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
						],
						pageOptions: {
							currentPage: 1,
							limit: 3,
							total: 0,
							behaviorType: '2'
						}
					},
					blackList: {
						list: [],
						loading: false,
						columns: [
							{ label: '黑名单记录主体及编号', prop: 'behaviorCode', align: 'center' },
							{ label: '黑名单认定依据', prop: 'behaviorContent', align: 'center' },
							{ label: '认定部门', prop: 'depart', align: 'center' },
							{ label: '决定期与有效期', prop: 'makeTime', align: 'center', width: '300', slot: 'slot_validityTime' },
							{ label: '备注', prop: 'remark', align: 'center' },
							{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
						],
						pageOptions: {
							currentPage: 1,
							limit: 3,
							total: 0,
							behaviorType: '3'
						}
					},
					blackListAndPenalty: {
						list: [],
						loading: false,
						columns: [
							{ label: '黑名单及联合惩戒主体及编号', prop: 'behaviorCode', align: 'center' },
							{ label: '内容描述', prop: 'behaviorContent', align: 'center' },
							{ label: '登记部门', prop: 'depart', align: 'center' },
							{ label: '登记时间', prop: 'makeTime', align: 'center' },
							{ label: '备注', prop: 'remark', align: 'center' },
							{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
						],
						pageOptions: {
							currentPage: 1,
							limit: 3,
							total: 0,
							behaviorType: '4'
						}
					}
				}
			}
		},
		computed: {
			...mapGetters(['vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			dynamicSilideList() {
				return [
					{
						name: '注册信息',
						num: this.registerRecords.registered.pageOptions.total,
						isVip: false
					},
					{
						name: '非注册信息',
						num: this.registerRecords.nonRegistered.pageOptions.total,
						isVip: false
					},
					{
						name: '待注册信息',
						num: this.registerRecords.waiting.pageOptions.total,
						isVip: true
					},
					{
						name: '工程业绩',
						num: this.personalProjectPerformancePageOptions.total,
						isVip: false
					},
					{
						name: '业绩技术指标',
						num: this.personTechnicalIndexPageOptions.total,
						isVip: false
					},
					{
						name: '良好行为',
						num: this.behaviorRecords.bad.pageOptions.total,
						isVip: false
					},
					{
						name: '不良行为',
						num: this.behaviorRecords.bad.pageOptions.total,
						isVip: false
					},
					{
						name: '行政处罚',
						num: this.behaviorRecords.punishment.pageOptions.total,
						isVip: true
					},
					{
						name: '黑名单记录',
						num: this.behaviorRecords.blackList.pageOptions.total,
						isVip: true
					},
					{
						name: '黑名单及联合惩戒',
						num: this.behaviorRecords.blackListAndPenalty.pageOptions.total,
						isVip: true
					}
				]
			}
		},
		watch: {},
		created() {},
		async mounted() {
			this.initSwiper()

			if (this.$route.query && this.$route.query.id) {
				this.personId = this.$route.query.id
				this.initPersonDetail()
				this.initPersonalProjectPerformanceList() // 初始化个人工程业绩列表
				this.initPersonTechnicalIndexList() // 初始化个人业绩技术指标列表
				this.initBehaviorRecords() // 初始化行为记录列表
				this.initRegisterRecords() // 新增初始化注册记录

				// 目前系统暂无会员控制，统计分析信息直接加载
				// if (this.isVip || this.isSVip) {
					// 所有图表分析数据加载promise
					const chartLoadingPromises = [
						this.getPersonPortrayal(),
						this.getPersonCerCountRank(),
						// this.getPersonCerTypeCount(),
						this.getPersonCerGradeRank(),
						this.getPersonRisk(),
						this.getPersonStability(),
						this.getPersonBehavior()
					]

					// 等待所有图表数据加载完毕
					Promise.all(chartLoadingPromises)
						.then(() => {
							// 所有分析图表数据已加载完成
							this.allChartDataIsLoadingDone = true
						})
						.catch(error => {
							console.log('图表加载报错：', error)
							// 即使出现了报错也要标记为已完成，避免导致无限等待
							this.allChartDataIsLoadingDone = true
						})
				// }
			}
		},
		methods: {
			// 初始化详情基础信息
			initPersonDetail() {
				this.loading = true
				const params = {
					personId: this.personId
				}
				getPersonDetail(params)
					.then(res => {
						this.detailInfo = res.data
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},

			// 获取人员分析-人员画像
			getPersonPortrayal() {
				const params = {
					personId: this.personId
				}

				this.portraitLoading = true
				return new Promise((resolve, reject) => {
					personPortrayal(params)
						.then(response => {
							const { data } = response

							if (data) {
								this.portraitData[0].value = Object.values(data)
							}

							this.portraitLoading = false
							resolve()
						})
						.catch(error => {
							this.portraitLoading = false
							reject(error)
						})
				})
			},

			// 获取人员证书分类分析
			getPersonCerTypeCount() {
				const params = {
					personId: this.personId
				}

				this.certTypeDataLoading = true

				return new Promise((resolve, reject) => {
					personCerTypeCount(params)
						.then(response => {
							const { data } = response

							this.certTypeDataLoading = false

							if (data && data.length) {
								this.certTypeData = data.map(item => ({
									value: item.certCount,
									name: item.certificateName
								}))
								this.certTypeTotal =
									data.reduce((sum, item) => {
										return sum + parseInt(item.certCount, 10)
									}, 0) + '本'
							}
							resolve()
						})
						.catch(error => {
							this.certTypeDataLoading = false
							reject(error)
						})
				})
			},

			// 获取人员分析-人员证书数量
			getPersonCerCountRank() {
				const params = {
					personId: this.personId
				}

				this.certCountRankLoading = true
				return new Promise((resolve, reject) => {
					personCerCountRank(params)
						.then(response => {
							const { data } = response

							this.certCountRankLoading = false
							if (data) {
								this.certCountRank.percentile = data.percentile
								this.certCountRank.title = data.percentile > 60 ? '高' : 50 < data.percentile <= 60 ? '中' : '低'
								this.certCountRank.subTitle = `证件数量超过${data.percentile}%同类人`
							}
							resolve()
						})
						.catch(error => {
							this.certCountRankLoading = false
							reject(error)
						})
				})
			},

			// 获取人员分析-人员证书等级
			getPersonCerGradeRank() {
				const params = {
					personId: this.personId
				}

				this.certGradeRankLoading = true
				return new Promise((resolve, reject) => {
					personCerGradeRank(params)
						.then(response => {
							const { data } = response

							this.certGradeRankLoading = false
							if (data) {
								this.certGradeRank.percentile = data.percentile
								this.certGradeRank.title = data.percentile > 60 ? '高' : 50 < data.percentile <= 60 ? '中' : '低'
								this.certGradeRank.subTitle = `证件级别超过${data.percentile}%同类人`
							}
							resolve()
						})
						.catch(error => {
							this.certGradeRankLoading = false
							reject(error)
						})
				})
			},

			// 获取人员风险（近一年）
			getPersonRisk() {
				const params = {
					personId: this.personId
				}

				this.personRiskDataLoading = true
				return new Promise((resolve, reject) => {
					personRisk(params)
						.then(response => {
							const { data } = response

							this.personRiskDataLoading = false

							if (data) {
								this.personRiskData[0].value = data.lowRisk
								this.personRiskData[1].value = data.mediumRisk
								this.personRiskData[2].value = data.highRisk
							}

							resolve()
						})
						.catch(error => {
							this.personRiskDataLoading = false
							reject(error)
						})
				})
			},

			// 获取人员稳定性分析
			getPersonStability() {
				const params = {
					personId: this.personId
				}

				this.stabilityDataLoading = true

				return new Promise((resolve, reject) => {
					personStability(params)
						.then(response => {
							const { data } = response

							this.stabilityDataLoading = false

							if (data && data.length) {
								this.stabilityMonthData = data.map(item => {
									const monthNumber = parseInt(item.thisMonth, 10)
									return `${monthNumber}月`
								})
								this.stabilityData = data.map(item => item.thisNumber)
							}

							resolve()
						})
						.catch(error => {
							this.stabilityDataLoading = false
							reject(error)
						})
				})
			},

			// 按统计周期进行查询
			handleStabilityPeriodChange() {
				// TODO： 按统计周期进行查询
			},

			// 获取人员个人行为记录分析
			getPersonBehavior() {
				const params = {
					personId: this.personId
				}

				this.behaviorDataLoading = true

				return new Promise((resolve, reject) => {
					personBehavior(params)
						.then(response => {
							const { data } = response

							this.behaviorDataLoading = false

							if (data && data.length) {
								this.goodBehaviorData = data.map(item => item.goodNumber)
								this.badBehaviorData = data.map(item => item.badNumber)
								this.blacklistData = data.map(item => item.blacklistNumber)
								this.behaviorMonthData = data.map(item => {
									const monthNumber = parseInt(item.thisMonth, 10)
									return `${monthNumber}月`
								})
							}
							resolve()
						})
						.catch(error => {
							this.behaviorDataLoading = false
							reject(error)
						})
				})
			},

			// 个人工程业绩列表
			initPersonalProjectPerformanceList() {
				// TODO： 分页查询个人工程业绩列表
				this.personalProjectPerformanceLoading = true
				const params = {
					personId: this.personId,
					page: this.personalProjectPerformancePageOptions.currentPage,
					limit: this.personalProjectPerformancePageOptions.limit
				}
				pageUserProjectPerformanceTab(params)
					.then(res => {
						this.personalProjectPerformanceList = res.data.records
						this.personalProjectPerformancePageOptions.total = res.data.total
						this.personalProjectPerformanceLoading = false
					})
					.catch(err => {
						this.personalProjectPerformanceLoading = false
					})
			},
			handlePersonalProjectPerformancePageChange(pager) {
				// TODO： 个人工程业绩列表翻页
				const { page, limit } = pager
				this.personalProjectPerformancePageOptions.currentPage = page
				this.personalProjectPerformancePageOptions.limit = limit
				this.initPersonalProjectPerformanceList()
			},
			// 个人工程业绩列表

			// 个人业绩技术指标
			initPersonTechnicalIndexList() {
				// TODO： 分页查询个人业绩技术指标列表
				this.personTechnicalIndexLoading = true
				const params = {
					personId: this.personId,
					page: this.personTechnicalIndexPageOptions.currentPage,
					limit: this.personTechnicalIndexPageOptions.limit
				}
				personTechnicalIndexPageTab(params)
					.then(res => {
						this.personTechnicalIndexList = res.data.records
						this.personTechnicalIndexPageOptions.total = res.data.total
						this.personTechnicalIndexLoading = false
					})
					.catch(err => {
						this.personTechnicalIndexLoading = false
					})
			},
			handlePersonTechnicalIndexPageChange(pager) {
				// TODO： 个人业绩技术指标列表翻页
				const { page, limit } = pager
				this.personTechnicalIndexPageOptions.currentPage = page
				this.personTechnicalIndexPageOptions.limit = limit
				this.initPersonTechnicalIndexList()
			},
			// 个人业绩技术指标

			// 查询个人行为
			fetchBehaviorRecords(type) {
				const record = this.behaviorRecords[type]
				record.loading = true
				const params = {
					personId: this.personId,
					page: record.pageOptions.currentPage,
					limit: record.pageOptions.limit,
					behaviorType: record.pageOptions.behaviorType
				}

				return personBehaviorRecordPageTab(params)
					.then(res => {
						record.list = res.data.records
						record.pageOptions.total = res.data.total
						record.loading = false
					})
					.catch(err => {
						record.loading = false
					})
			},

			// 初始化各种行为记录
			initBehaviorRecords() {
				const behaviorTypes = Object.keys(this.behaviorRecords)

				// 并行发起所有请求
				return Promise.all(behaviorTypes.map(type => this.fetchBehaviorRecords(type)))
			},

			// 页面变更处理
			handleBehaviorPageChange(pager, type) {
				const record = this.behaviorRecords[type]
				record.pageOptions.currentPage = pager.page
				record.pageOptions.limit = pager.limit
				this.fetchBehaviorRecords(type)
			},
			// 查询个人行为

			// 初始化注册记录
			fetchRegisterRecords(type) {
				const record = this.registerRecords[type]
				record.loading = true
				const params = {
					personId: this.personId,
					page: record.pageOptions.currentPage,
					limit: record.pageOptions.limit,
					registerType: record.pageOptions.registerType
				}

				return pageCertificateByPersonId(params)
					.then(res => {
						record.list = res.data.records
						record.pageOptions.total = res.data.total
						record.loading = false
					})
					.catch(err => {
						record.loading = false
					})
			},
			initRegisterRecords() {
				const registerTypes = Object.keys(this.registerRecords)
				return Promise.all(registerTypes.map(type => this.fetchRegisterRecords(type)))
			},
			handleRegisterPageChange(pager, type) {
				const record = this.registerRecords[type]
				record.pageOptions.currentPage = pager.page
				record.pageOptions.limit = pager.limit
				this.fetchRegisterRecords(type)
			},
			// 初始化注册记录

			// 初始化vip滚动
			initSwiper() {
				new Swiper('.vip-swiper', {
					direction: 'vertical', // 垂直方向滚动
					loop: true, // 循环滚动
					autoplay: {
						delay: 3000, // 3秒切换一次
						disableOnInteraction: false
					},
					slidesPerView: 1, // 每次显示1条
					spaceBetween: 0 // 间距为0
				})
			},
			// 初始化vip滚动

			// 切换Tab
			changeSlideTab(index) {
				this.activeSlideTabIndex = index

				// 获取点击的tab名称
				const tabName = this.dynamicSilideList[index].name
				console.log(this.dynamicSilideList[index].name)

				// 查找所有slideTitle元素
				const titles = document.querySelectorAll('.slideTitle')

				let targetTitle = null

				// 遍历查找匹配的标题

				// 遍历查找匹配的标题
				for (const title of titles) {
					// 获取h4元素
					const h4Element = title.querySelector('h4')
					// 获取h4的文本内容，并去除前后空格
					const h4Text = h4Element ? h4Element.childNodes[0].textContent.trim() : ''

					// 先进行全等判断
					if (h4Text === tabName) {
						targetTitle = title
						break // 找到全等匹配，立即结束循环
					} else if (h4Text.includes(tabName)) {
						// 如果没有全等匹配，再进行包含判断
						targetTitle = title
					}
				}

				if (targetTitle) {
					this.$nextTick(() => {
						const elementPosition = targetTitle.getBoundingClientRect().top
						const offsetPosition = elementPosition + window.pageYOffset - 66

						window.scrollTo({
							top: offsetPosition,
							behavior: 'smooth'
						})
					})
				}
			},
			getWorkStatus(workStatus) {
				if (workStatus === '1') {
					return '在职'
				} else if (workStatus === '0') {
					return '离职'
				} else {
					return '未知'
				}
			},

			// 收藏与取消收藏
			handleIsCollect(id, flag) {
				// 如果左侧人员信息还没获取出来，则直接return
				if (!id) {
					return
				}
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.PERSON
				}
				if (flag) {
					removeUserCollect(params).then(res => {
						this.$message.success('已取消收藏')
						this.detailInfo.isCollect = false
						// this.initPersonDetail()
					})
				} else {
					saveUserCollect(params).then(res => {
						this.$message.success('收藏成功')
						this.detailInfo.isCollect = true
						// this.initPersonDetail()
					})
				}
			},
			// 监控与取消监控
			handleIsMonitoring(id, flag) {
				// 会员判断逻辑已屏蔽
				// if (!this.isVip && !this.isSVip) {
				// 	this.$message.error('暂不是高级会员，请先购买会员')
				// 	this.payVisible = true
				// 	return
				// }

				// 如果左侧人员信息还没获取出来，则直接return
				if (!id) {
					return
				}

				const params = {
					monitoringIds: [id],
					monitoringType: COLLECT_TYPE_STATE.PERSON
				}
				if (flag) {
					removeUserMonitoring(params).then(res => {
						this.$message.success('已取消监控')
						this.detailInfo.isMonitoring = false
						// this.initPersonDetail()
					})
				} else {
					saveUserMonitoring(params).then(res => {
						this.$message.success('监控成功')
						this.detailInfo.isMonitoring = true
						// this.initPersonDetail()
					})
				}
			},

			// 人员报告导出
			async handleExportPersonReport() {
				// 会员判断逻辑已屏蔽
				// if (!this.isVip && !this.isSVip) {
				// 	this.$message.error('暂不是高级会员，请先购买会员')
				// 	this.payVisible = true
				// 	return
				// }

				// 权益耗尽校验已屏蔽
				// const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT.BGDC)
				// if (!isValid) {
				// 	return
				// }

				if (!this.allChartDataIsLoadingDone) {
					this.$modal.msg('分析数据正在加载中，请等待...')
					return
				}

				try {
					// 定义图表名称映射
					const chartConfigs = [
						{ ref: 'radarChart', name: '人员画像图', key: 'radarChart' },
						{ ref: 'certCountChart', name: '证件数量分析图', key: 'certCountChart' },
						{ ref: 'certGradeChart', name: '证件级别分析图', key: 'certGradeChart' },
						// { ref: 'certTypeChart', name: '证书类型分析图', key: 'certTypeChart' },
						{ ref: 'riskChart', name: '风险评估图', key: 'riskChart' },
						{ ref: 'stabilityChart', name: '稳定性分析图', key: 'stabilityChart' },
						{ ref: 'behaviorChart', name: '行为记录图', key: 'behaviorChart' }
					]

					// 收集所有图表的图片数据（异步处理）
					const chartPromises = chartConfigs.map(config => {
						return new Promise(resolve => {
							try {
								const chartRef = this.$refs[config.ref]
								if (chartRef && chartRef.$refs && chartRef.$refs.echartsRef) {
									const imageData = chartRef.$refs.echartsRef.exportAsFile(config.name + '.png')
									if (imageData) {
										resolve({
											key: config.key,
											name: config.name,
											imageData: imageData
										})
									} else {
										console.warn(`图表 ${config.name} 导出为空`)
										resolve(null)
									}
								} else {
									console.warn(`图表 ${config.name} 引用不存在`)
									resolve(null)
								}
							} catch (error) {
								console.error(`导出图表 ${config.name} 时出错:`, error)
								resolve(null)
							}
						})
					})

					// 等待所有图表处理完成
					const chartResults = await Promise.all(chartPromises)

					// 过滤掉空值，并构建请求数据
					const chartImages = {}
					chartResults.forEach(result => {
						if (result) {
							chartImages[result.key] = {
								name: result.name,
								imageData: result.imageData
							}
						}
					})

					console.log('chartImages:', chartImages)
					const formData = new FormData()

					formData.append('personId', this.personId)
					// 将所有图表文件添加到 FormData 中
					Object.keys(chartImages).forEach(key => {
						if (chartImages[key] && chartImages[key].imageData) {
							// 使用图表名称作为文件名，将文件对象添加到 files 字段
							formData.append('files', chartImages[key].imageData)
						}
					})

					// 执行报告生成并下载接口
					await reportGenerationDownload(exportPersonReport(), formData, {
						defaultFileName: `人员报告-${this.detailInfo.name || ''}.pdf`
					})

					this.$modal.msgSuccess('报告导出成功')
				} catch (error) {
					console.error('导出报告错误:', error)
				}
			},

			// 打开弹窗
			async handleOpenDialog(type, title, id, idCard) {
				this.currentDialogInfoId = id
				this.peopleIdCard = idCard
				this.currentDialogComponent = type
				this.showDialog = true
				this.dialogTitle = title
			},
			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},

			// 前往商城购买
			handleToPurchase() {
				this.$router.push({
					path: '/mallStore/index'
				})
			},

			handleVipCancel() {
				this.payVisible = false
			},

			// 跳转会员权益办理页面
			handleLocationMemberBenefits() {
				this.$router.push({
					path: '/member-benefits'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.personDetail-container {
		background-color: #eff6f9;
		.personDetail-content {
			width: $main-page-width;
			margin: 0 auto;
			padding-top: 20px;
			.register-table {
				padding-bottom: 20px;
			}
			.information-container {
				margin-bottom: 20px;
				.information-content {
					display: flex;
					justify-content: space-between;
					align-items: center;
					.basic-content {
						width: 1045px;
						height: 270px;
						background-color: #ffffff;
						padding: 20px;
						.cjt-tabs__content {
							padding-top: 37px;
							display: flex;
							align-items: center;
							padding-left: 18px;
							img {
								margin-right: 40px;
							}
							.name {
								font-size: 20px;
								color: #333333;
								font-weight: bold;
								margin-bottom: 28px;
								.on-job {
									width: 106px;
									height: 28px;
									background-color: #2599fb;
									border-radius: 0px 10px 0px 10px;
									margin-left: 20px;
									font-size: 16px;
									color: #ffffff;
									text-align: center;
									line-height: 28px;
									display: inline-block;
									font-weight: normal;
								}
							}
							p {
								font-size: 16px;
								color: #333333;
								width: 542px;
								display: flex;
								justify-content: space-between;
								line-height: 15px;
							}
						}
					}
					.people-content {
						width: 335px;
						height: 270px;
						background-color: #ffffff;
						position: relative;
						.people-echarts {
							height: calc(100% - 49px);
						}
					}
				}
			}
			.table-container {
				.table-content {
					display: flex;
					justify-content: space-between;
					.table-box {
						width: 1045px;
						.tab-container {
							min-height: 376px;
						}
					}

					.charts-box {
						width: 335px;
						background-color: #fff;
						.charts-content {
							padding: 0px 15px;
							position: relative;
							.chars-title {
								font-size: 18px;
								color: #333333;
								font-weight: bold;
								margin-top: 30px;
								position: relative;
								padding-left: 21px;
								&::before {
									display: block;
									content: '';
									width: 4px;
									height: 17px;
									background-color: #236fca;
									position: absolute;
									left: 9px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
							.divider-title {
								margin-top: 27px;
							}
							.progress-box {
								position: relative;
								width: 222px;
								height: 185px;
								margin: 0 auto;
								margin-top: 20px;
								margin-bottom: 20px;
							}

							.chart-box {
								position: relative;
							}

							.poster-container {
								margin-top: 50px;
								margin-bottom: 62px;
							}
							.line-box {
								width: 80%;
								margin: 0 auto;
								margin-top: 40px;
							}
						}
					}
				}
				.tab-container {
					width: 100%;
					padding: 20px 20px 0px 20px;
					background: #fff;
					.pagination-container {
						padding-top: 9px;
						padding-bottom: 12px;
					}
				}
			}

			.vip-title {
				font-size: 20px;
				color: #333333;
				font-weight: bold;
				padding: 25px 0px 0px 22px;
				position: relative;
				span {
					position: absolute;
					height: 18px;
					line-height: 18px;
					left: 106px;
					top: 13px;
					padding: 0px 7px;
				}
			}

			.cjt-tabs__item {
				&::after {
					height: 4px;
					background-color: #2671cb;
				}
				.cjt-tabs__item-text {
					font-size: 20px;
				}
			}
			.cjt-tabs__item.active {
				color: #333333;
			}
			.mt20 {
				margin-top: 20px;
			}
		}
	}
	.max-text {
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	::v-deep {
		.el-button {
			padding: 0px 0px;
		}
	}
</style>
<style lang="scss">
	.el-tooltip__popper {
		width: 400px; // 可以调整为您需要的宽度
		max-width: 80%; // 或者设置最大宽度百分比
		word-break: break-all; // 如果需要自动换行可以添加这个
	}
</style>
